import YousignAPI from "./../YousignAPI";

class ServiceYousign {

	constructor() {
		this.yousignAPI = new YousignAPI();
	}

	getProcedureByID(procedureID) {
		const url =  `/procedures/${procedureID}`;
		return this.yousignAPI.callApi(url, false, "GET");
	}

	getFileContent(fileID) {
		const url = `${fileID}/download`;
		return this.yousignAPI.callApi(url, true, "GET");
	}

}

const serviceYousign = new ServiceYousign();
export default serviceYousign;



// WEBPACK FOOTER //
// ./src/opencell/services/ServiceYousign.js